import {TMenuStructure} from 'store/slices/menu-slice';

import {NEWS_SECTION_CODE} from '../model/constants';

export const hasMenuItemNewsSection = (menuStructure: TMenuStructure | null): boolean => {
    if (!menuStructure) return false;

    return menuStructure?.some(
        item => item.parameters && item.parameters.sectionCode === NEWS_SECTION_CODE,
    );
};
